import styled from 'styled-components';

import { mediaQueryLaptopMin } from '@/styleUtils';

export const Wrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  margin: 0 auto;
  width: 100%;
  padding: 16px;
`;

export const Main = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media all and ${mediaQueryLaptopMin} {
    gap: 24px;
  }
`;
